import React, { useState } from "react";
import { useGoogleLogin } from "@react-oauth/google";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useConfig } from "@/context/ConfigContext";

const GIcon = () => (
  <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
    <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z" />
    <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" />
    <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-7.9l-6.5 5C9.5 39.6 16.2 44 24 44z" />
    <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z" />
  </svg>
);

function Inner({ onDone, onError }) {
  const { googleLogin } = useAuth();
  const [busy, setBusy] = useState(false);
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const start = useGoogleLogin({
    flow: "auth-code",
    onSuccess: async ({ code }) => {
      setBusy(true);
      try { await googleLogin(code); onDone?.(); } catch (e) { onError?.(e.response?.data?.detail || "Google sign-in failed"); } finally { setBusy(false); }
    },
    onError: () => onError?.("Google sign-in was cancelled"),
  });
  return (
    <button type="button" onClick={() => start()} disabled={busy} data-testid="google-login-btn"
      className="w-full py-2.5 rounded-lg bg-white text-black text-sm font-bold flex items-center justify-center gap-2.5 hover:bg-white/90 transition-colors disabled:opacity-60">
      {busy ? <Loader2 size={16} className="animate-spin" /> : <GIcon />} Continue with Google
    </button>
  );
}

export default function GoogleButton(props) {
  const { google_client_id } = useConfig();
  if (!google_client_id) return null;
  return <Inner {...props} />;
}
